var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),(_vm.$store.state.seqPonto !== 0)?_c('router-view'):(_vm.show)?_c('SeletorPonto',{on:{"selected":_vm.startApp}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }